/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from "react";
import { useTranslation } from "react-i18next";

import CreateRecordButtonLayout from "../layout/CreateRecordButtonLayout";
import EguMachineRentalOutCreateDialog from "../dialogTypes/EguMachineRentalOutCreateDialog";

function EguMachineRentalOutCreateButton ( props ) {
    const {t} = useTranslation();
    const {id, schema, refresh, onSuccess, modifyUrlCallback, ...others} = props;
    const [open, setOpen] = useState(false);

    const onOpen = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const onCreateSuccess = (msg) => {
        if (onSuccess) {
            onSuccess (msg);
        }
        refresh.refresh ();
    };

    return (
        <>
            <CreateRecordButtonLayout id={id+"create-button"} onClick={onOpen} {...others} />
            <EguMachineRentalOutCreateDialog
                id={id+"append-dialog"}
                title={schema ? t(`dialog.title.${schema.name}.create`) : ""}
                schema={schema}
                open={open}
                onClose={onClose}
                onSuccess={onCreateSuccess}
                modifyUrlCallback={modifyUrlCallback}
            />
        </>
    );
}

export default EguMachineRentalOutCreateButton;

